import { RefObject, useEffect, useRef, useState } from "react";

type Size = { width: number; height: number };

function useElementSizeListener<T extends HTMLElement>(): readonly [
  RefObject<T>,
  Size
] {
  const ref = useRef<T>(null);
  const [size, setSize] = useState<Size>({ width: 0, height: 0 });

  useEffect(() => {
    setSize({
      width: ref.current?.offsetWidth || 0,
      height: ref.current?.offsetHeight || 0,
    });
  }, [ref.current?.offsetHeight, ref.current?.offsetWidth]);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new ResizeObserver(([entry]) => {
      const { clientHeight, clientWidth } = entry.target;
      setSize({ width: clientWidth, height: clientHeight });
    });

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, size] as const;
}

export default useElementSizeListener;
